export default __webpack_public_path__ + "static/media/img_explosion.min.ad5a6617.png";